module.exports = __webpack_public_path__ + "static/media/mac-now-logo-white.61e32f34.svg";